import * as url from 'url';

export const urlToPathname = (urlString: string, { preserveQueryParams = false } = {}): string => {
  const parsed = url.parse(urlString || '');
  return parsed.pathname
    ? parsed.pathname + ((preserveQueryParams && parsed.search) || '') + (parsed.hash ? parsed.hash : '')
    : '';
};
